import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitGrowUpFarmsFoodQuestionnaire } from "../../redux/actions/growUpFarmsActions";

const FoodSafetyQuestionnaire = ({ appData, submitQuestionnaire }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    bringFood: {
      key: "bringFood",
      title:
        "1. Can I bring M&M and Snicker (peanut) in the Clean Room or Warehouse?",
      value: getVal("bringFood"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    eatFood: {
      key: "eatFood",
      title: "2. Can I eat food in the Warehouse?",
      value: getVal("eatFood"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    washHands: {
      title:
        "3. How often do I need to wash my hands? (chose the right answer)",
      value: getVal("washHands"),
      type: "radio",
      radioOptions: [
        "Beginning of the day",
        "When entering changing room",
        "After eating",
      ],
      mandatory: true,
    },
    insects: {
      title: "4. What should I do if I see insects? (chose the right answer)",
      value: getVal("insects"),
      type: "radio",
      radioOptions: [
        "Report to my manager",
        "Hope it will get out",
        "Try to kill it",
      ],
      mandatory: true,
    },
    allergens: {
      title: "5. Chose the right answer:",
      value: getVal("allergens"),
      type: "radio",
      radioOptions: [
        "There are 14 allergens and none is handled at Grow Up Farm Recipe Centre",
        "There are 12 allergens and none is handled at Grow Up Farm Recipe Centre",
        "There are 14 allergens and 1 of them is handled at Grow Up Farm Recipe Centre",
      ],
      mandatory: true,
    },
    rules: {
      title: "6. Chose the right answer:",
      value: getVal("rules"),
      type: "radio",
      radioOptions: [
        "I have to remove my jewellery before entering the Clean Room",
        "Only blue plasters are allowed",
        "I can bring my office pen",
      ],
      mandatory: true,
    },
    bringPhone: {
      key: "bringPhone",
      title: "7. Can I bring my mobile phone with me in the Clean Room?",
      value: getVal("bringPhone"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hair: {
      title: "8. What is the right answer?",
      value: getVal("hair"),
      type: "radio",
      radioOptions: [
        "My hair net has to cover my ears",
        "My hair net has to cover my hair only",
        "My hair net has to cover my ears & hair",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.growUpFarmsOnboarding && appData.growUpFarmsOnboarding.YGUF;
  const redirectBack = () => {
    history.push("/profile/edit/grow-up-farms-onboarding");
  };
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuestionnaire(
      "foodSafetyQuestionnaire",
      {
        ...fieldValuesPayload,
      },
      "YGUF"
    );
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Food Safety Questionnaire"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"growUpFarms"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

FoodSafetyQuestionnaire.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitQuestionnaire: submitGrowUpFarmsFoodQuestionnaire,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FoodSafetyQuestionnaire);
